export const DIAMOND_SIZE = 12;
export const LINE_WIDTH = 3;
export const BADGE_SIZE = 13;
